import { render, staticRenderFns } from "./FeatureAnnouncement.vue?vue&type=template&id=59ed2685&scoped=true"
import script from "./FeatureAnnouncement.vue?vue&type=script&lang=js"
export * from "./FeatureAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./FeatureAnnouncement.vue?vue&type=style&index=0&id=59ed2685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed2685",
  null
  
)

export default component.exports